module.exports = __webpack_public_path__ + "img/tf-1.d5aaff89.jpg";